module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "services-page"
    }
  }, [_c('nav-bar'), _vm._v(" "), _c('swiper', {
    ref: "mySwiper5",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-image": "url('../assets/img/c1.jpg')",
      "background-size": "cover",
      "background-repeat": "no-repeat"
    }
  }, [_c('div', {
    staticClass: "slide-center"
  }, [_c('h1', {
    staticClass: "page__title-white"
  }, [_vm._v(_vm._s(_vm.$t('Pricing')))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('Valuation_pricing')) + " - " + _vm._s(_vm.$t('VAT_not_included')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "page__container main"
  }, [_c('div', {
    staticClass: "page__content left"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('Pricing_text_01')) + ".\n\n\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "page__content right",
    staticStyle: {
      "background-color": "whitesmoke",
      "padding": "1rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'quote-request'
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Request_a_quote_here')))])]), _vm._v("\n\t\t\t\t\t. " + _vm._s(_vm.$t('Pricing_text_02')) + ".\n\t\t\t\t")])], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v(_vm._s(_vm.$t('Dwellings')) + ", " + _vm._s(_vm.$t('Parking_spaces')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Storerooms')))]), _vm._v(" "), _c('table', {
    staticClass: "d-table-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Appraisal_value')) + " " + _vm._s(_vm.$t('in_01')) + " " + _vm._s(_vm.$t('thousands_of_euros')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Mortgage_Appraisal_Fees')) + " *"), _c('sup', [_vm._v("1")]), _vm._v(" *"), _c('sup', [_vm._v("2")])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Informative_Appraisal_Fees')) + "  *"), _c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.valuation_prices.group_A), function(range, key, index) {
    return (index < 6) ? _c('tr', [_c('td', [_vm._v(_vm._s(range.floor / 1000) + " a " + _vm._s(range.ceil / 1000))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(range.mortgage_valuation_fee) + " €\n\t\t\t\t\t"), (range.increment_pct_mortgage_valuation > 0) ? _c('span', {
      staticClass: "small"
    }, [_vm._v("\n\t\t\t\t\t+ " + _vm._s(range.increment_pct_mortgage_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(range.standard_valuation_fee) + " €\n\t\t\t\t\t"), (range.increment_pct_standard_valuation > 0) ? _c('span', {
      staticClass: "small"
    }, [_vm._v("\n\t\t\t\t\t+ " + _vm._s(range.increment_pct_standard_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t")]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('Higher_values')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))])])], 2)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v(_vm._s(_vm.$t('Commercial_premises')) + ", " + _vm._s(_vm.$t('Offices')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Industrial_warehouses')))]), _vm._v(" "), _c('table', {
    staticClass: "d-table-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Appraisal_value')) + " " + _vm._s(_vm.$t('in_01')) + " " + _vm._s(_vm.$t('thousands_of_euros')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Mortgage_Appraisal_Fees')) + " *"), _c('sup', [_vm._v("1")]), _vm._v(" *"), _c('sup', [_vm._v("2")])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Informative_Appraisal_Fees')) + "  *"), _c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.valuation_prices.group_B), function(range, key, index) {
    return (index < 5) ? _c('tr', [_c('td', [_vm._v(_vm._s(range.floor / 1000) + " a " + _vm._s(range.ceil / 1000))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(range.mortgage_valuation_fee) + " €\n\t\t\t\t\t"), (range.increment_pct_mortgage_valuation > 0) ? _c('span', {
      staticClass: "small"
    }, [_vm._v("\n\t\t\t\t\t+ " + _vm._s(range.increment_pct_mortgage_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(range.standard_valuation_fee) + " €\n\t\t\t\t\t"), (range.increment_pct_standard_valuation > 0) ? _c('span', {
      staticClass: "small"
    }, [_vm._v("\n\t\t\t\t\t+ " + _vm._s(range.increment_pct_standard_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t")]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('Higher_values')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))])])], 2)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t('Buildings')) + ", " + _vm._s(_vm.$t('Property_developments')) + ", " + _vm._s(_vm.$t('Properties_under_economic_exploitation')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Land_pl')))]), _vm._v(" "), _c('table', {
    staticClass: "d-table-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Appraisal_value')) + " " + _vm._s(_vm.$t('in_01')) + " " + _vm._s(_vm.$t('thousands_of_euros')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Fees')) + " *"), _c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.valuation_prices.group_C), function(range, key, index) {
    return (index < 6) ? _c('tr', [_c('td', [_vm._v(_vm._s(range.floor / 1000) + " a " + _vm._s(range.ceil / 1000))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(range.standard_valuation_fee) + " €\n\t\t\t\t\t"), (range.increment_pct_standard_valuation > 0) ? _c('span', {
      staticClass: "small"
    }, [_vm._v("\n\t\t\t\t\t+ " + _vm._s(range.increment_pct_standard_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t")]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('Higher_values')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))])])], 2)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v(_vm._s(_vm.$t('Machinery')) + ", " + _vm._s(_vm.$t('Expropriations')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('others')) + ": "), _c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v(_vm._s(_vm.$t('acc_Budget')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("\n\t\t\t*"), _c('sup'), _vm._v(" " + _vm._s(_vm.$t('Pricing_text_03')) + ".\n\n\t\t"), _c('br'), _vm._v("\n\t\t\t*"), _c('sup', [_vm._v("1")]), _vm._v(" " + _vm._s(_vm.$t('Pricing_text_04')) + ".\n\t\t"), _c('br'), _vm._v("\n\t\t\t*"), _c('sup', [_vm._v("2")]), _vm._v(" " + _vm._s(_vm.$t('Pricing_text_05')) + ".\n\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('Report_content')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "page__container main"
  }, [_c('ul', [_c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Report_content_text_01')) + ".\n\t\t\t\t\t")]), _vm._v(" "), _c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Report_content_text_02')) + ".\n\t\t\t\t\t")]), _vm._v(" "), _c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Report_content_text_03')) + ".\n\t\t\t\t\t")]), _vm._v(" "), _c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Report_content_text_04')) + ".\n\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "page",
    staticStyle: {
      "background": "whitesmoke"
    }
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('Other_services')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v(_vm._s(_vm.$t('Energy_Efficiency_Certificate')) + ": "), _c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v(_vm._s(_vm.$t('EEC_conditions')) + ". " + _vm._s(_vm.$t('OT_conditions')) + ".")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v(_vm._s(_vm.$t('Occupancy_Card_and_Certificate')) + ": "), _c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v(_vm._s(_vm.$t('OCC_conditions')) + ". " + _vm._s(_vm.$t('OT_conditions')) + ".")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t('Energy_Efficiency_Certificate')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Occupancy_Card')) + " " + _vm._s(_vm.$t('of_the_same_property')) + ": "), _c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v(_vm._s(_vm.$t('EECOCC_conditions')) + ". " + _vm._s(_vm.$t('OT_conditions')) + ".")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v(_vm._s(_vm.$t('Surveying')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Measurements')) + ": "), _c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v(_vm._s(_vm.$t('acc_Budget')))])])]), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('strong', [_vm._v("\n\t\t\t*"), _c('sup', [_vm._v("3")]), _vm._v(" " + _vm._s(_vm.$t('Pricing_text_06')) + ".\n\t\t")])]), _vm._v(" "), _c('logo-bar'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12fb11ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Pricing.vue
// module id = 2105
// module chunks = 0